'use strict';

/* eslint-disable no-console */
define('lib/analytics/click.manual',[
  'jquery',
  './context.get',
  './blocks/index',
  './trigger',
  './config'
], function (
  $,
  contextGet,
  blocks,
  trigger,
  config
) {
  /*
    TODO: Is this REALLY the way to 'manually' trigger click events?
  */
  return function anClickManual(scope, target) {
    var $scope = $(scope);
    var $target = $(target);
    if (config.debug && config.debug.logClicks) {
      console.log('DL 1.5 manual click');
    }
    trigger('aa-link', [
      contextGet($target, $scope), // provide start and end contexts
      blocks.linkBlock($target)
    ]);
  };
});

